import { render } from "./ExperienceDetailView.vue?vue&type=template&id=3dfed416&scoped=true&ts=true"
import script from "./ExperienceDetailView.vue?vue&type=script&lang=ts"
export * from "./ExperienceDetailView.vue?vue&type=script&lang=ts"

import "./ExperienceDetailView.vue?vue&type=style&index=0&id=3dfed416&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfed416"]])

export default __exports__